<template>
  <div class="sidebar-dropdown">
    <div
      :class="{ open: showChildren }"
      class="sidebar-item"
      @click="toggleShowDropdownChildren"
    >
      <div class="sidebar-item__icon-container">
        <span class="sidebar-item__icon">
          <slot name="icon"></slot>
        </span>
      </div>
      <div class="sidebar-item__title">
        <p>{{ title }}</p>
      </div>
      <div class="sidebar-item__dropdown-icon-container">
        <span class="sidebar-item__dropdown-icon">
          <svg
            :class="{ open: showChildren }"
            class="dropdown-icon"
            width="6"
            height="10"
            viewBox="0 0 6 10"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1 9L5 5L1 1"
              stroke="#4b88d1"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </span>
      </div>
    </div>
    <div
      :class="{ show: showChildren }"
      ref="dropdownChild"
      class="sidebar-item__children"
    >
      <slot name="children"> </slot>
    </div>
  </div>
</template>

<script>
export default {
  props: ["title", "url"],
  data() {
    return {
      showChildren: false,
    };
  },
  methods: {
    toggleShowDropdownChildren() {
      let childContent = this.$refs.dropdownChild;
      if (childContent.style.maxHeight) {
        childContent.style.maxHeight = null;
        childContent.style.marginBottom = null;
      } else {
        childContent.style.maxHeight = childContent.scrollHeight + 6 + "px";
        childContent.style.marginBottom = "1rem";
      }
      this.showChildren = !this.showChildren;
    },
  },
};
</script>

<style scoped>
.sidebar-dropdown {
  cursor: pointer;
}
p {
  color: #9bbbe2;
  font-weight: normal;
  transition: all ease 0.5s;
}
.sidebar-item.open p {
  color: #ffffff;
  opacity: initial;
}
.sidebar-item {
  display: flex;
  height: 100%;
  align-items: center;
  padding: 0.6rem 1rem;
}
.sidebar-item__icon-container {
  display: flex;
  height: 100%;
  align-items: center;
}
.sidebar-item__icon {
  margin-right: 1rem;
}
.sidebar-item__dropdown-icon-container {
  margin-left: auto;
}
.sidebar-item__children {
  display: flex;
  flex-direction: column;
  max-height: 0;
  overflow: hidden;
  transition: all ease 0.5s;
}

.sidebar-item__children.show {
  height: auto;
}

.sidebar-item__children a {
  color: #9bbbe2;
  font-weight: normal;
  padding: 0.5rem 0 0.5rem 3rem;
}
.sidebar-item__children > .router-link-active {
  color: #ffffff;
  font-weight: bold;
}
.sidebar-item__children a:hover {
  text-decoration: none;
}

.dropdown-icon {
  transition: all ease 0.5s;
}
.dropdown-icon.open {
  transform: rotate(90deg);
}
</style>
